import { Select } from "antd";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import qs from 'qs';
import Button from "../../Button";
const { Option } = Select;

const MemberSearch: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const [memberType, setMemberType] = useState('S,P');
  const [privacyInfo, setPrivacyInfo] = useState('memberName');
  const [keyword, setKeyword] = useState('');

  const onSearch = () => {
    const params: any = { page: 1 };

    if (memberType) {
      params.memberType = memberType
    }
    if (privacyInfo && keyword) {
      params.privacyInfo = privacyInfo;
      params.keyword = keyword.trim();
    } 

    history.push(`/homepage/member?${qs.stringify(params)}`);
  }

  return (
    <ul className="search-bx">
      <li>
        <label>{t('common.column.category')}</label>
        <div>
          <Select
            value={memberType}
            onChange={value => setMemberType(value)}
          >
            <Option value='S,P'>{t('common.text.all')}</Option>
            <Option value='S'>{t('homepage.member.11')}</Option>
            <Option value='P'>{t('homepage.member.10')}</Option>
          </Select>
        </div>
      </li>
      <li>
        <div>
          <Select
            value={privacyInfo}
            onChange={value => setPrivacyInfo(value)}
          >
            <Option value='memberName'>{t('homepage.member.17')}</Option>
            <Option value='webId'>{t('homepage.member.33')}</Option>
            <Option value='mobilePhone'>{t('homepage.member.34')}</Option>
          </Select>
        </div>
        <input
          type="text"
          className="form-control"
          placeholder={t('homepage.member.35')}
          value={keyword}
          onChange={e => setKeyword(e.target.value)}
          onKeyPress={e => { if (e.key === 'Enter') onSearch() }}
        />
        <div className="comm-btn__area">
          <Button
            className="btn-basic small black"
            onClick={() => onSearch()}
            text={t('common.button.search')}
          />
        </div>
      </li>
    </ul>
  );
}

export default MemberSearch;